import locales from '../../../../config/interface_locales.json';

export const DEFAULT_LOCALE = locales.default;
export const FALLBACK_LOCALE = locales.fallback;

export function resolveInterfaceLocale(locale) {
  if (locales.available.includes(locale)) return locale;
  const language = locale?.replace('-', '_').split('_')[0];
  return language === 'en' ? FALLBACK_LOCALE : DEFAULT_LOCALE;
}
